import React from "react";
import { Carousel } from "react-bootstrap";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./PorQueElegirnos.css";

const PorQueElegirnos = () => {
  const items = [
    {
      title: "Calidad Garantizada",
      description:
        "Ofrecemos productos de alta calidad.  Nos aseguramos de que cada uno de nuestros artículos sean resistentes, para ello realizamos un refuerzo en los mismos, lo que hace que garantice su funcionalidad y su durabilidad.",
    },
    {
      title: "Entrega inmediata",
      description:
        "Nos destacamos por tener una entrega eficiente. Estamos comprometidos en asegurar que los pedidos lleguen a tiempo y en perfectas condiciones ya que entendemos y respetamos los plazos de nuestros clientes.",
    },
    {
      title: "Atención Personalizada",
      description:
        "Nos adaptamos a las necesidades e inquietudes que presentan cada uno de nuestros clientes de manera personalizada, ofreciendo soluciones a medida, para garantizar una completa satisfacción.",
    },
  ];

  return (
    <div className="por-que-elegirnos-container">

      <div className="por-que-elegirnos-desktop justify-content-center my-5">
        <h2 className="por-que-elegirnos-title-desktop">¿Por qué <br /> elegirnos?</h2>
        <div className="por-que-elegirnos-items">
          {items.map((item, index) => (
            <div className="item" key={index}>
              <h3 className="item-title">{item.title}</h3>
              <p className="item-description">{item.description}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="por-que-elegirnos-mobile">
        <h2 className="por-que-elegirnos-title-mobile">¿Por qué elegirnos?</h2>
        <Carousel
          interval={4000}
          controls={true}
          indicators={false}
          pause="hover"
          nextIcon={<FaChevronRight className="carousel-icon" />}
          prevIcon={<FaChevronLeft className="carousel-icon" />}
        >
          {items.map((item, index) => (
            <Carousel.Item key={index}>
              <div className="item">
                <h3 className="item-title">{item.title}</h3>
                <p className="item-description">{item.description}</p>
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default PorQueElegirnos;
